import React from "react";
import { DropdownChevronLeft, DropdownChevronRight } from "@vibe/icons";

interface UsageTablePaginationProps {
  currentPage: number;
  totalPages: number;
  isLoading?: boolean;
  onNext: () => void;
  onPrevious: () => void;
}

const pageButtonBaseClass =
  "flex h-6 w-6 items-center justify-center rounded-md border-0 bg-transparent p-0 transition-colors";

const UsageTablePagination = ({
  currentPage,
  totalPages,
  isLoading = false,
  onNext,
  onPrevious,
}: UsageTablePaginationProps) => {
  if (totalPages <= 1) {
    return null;
  }

  const canGoPrevious = currentPage > 1;
  const canGoNext = currentPage < totalPages && !isLoading;

  return (
    <div className="flex items-center justify-center gap-2">
      <button
        type="button"
        aria-label="Previous usage page"
        disabled={!canGoPrevious}
        onClick={onPrevious}
        className={`${pageButtonBaseClass} ${
          canGoPrevious ? "cursor-pointer hover:bg-[#f6f7fb]" : "cursor-not-allowed opacity-50"
        }`}
      >
        <DropdownChevronLeft color="#676879" />
      </button>
      <span className="min-w-4 text-center text-xs font-semibold text-[#676879]">
        {currentPage}
      </span>
      <button
        type="button"
        aria-label="Next usage page"
        disabled={!canGoNext}
        onClick={onNext}
        className={`${pageButtonBaseClass} ${
          canGoNext ? "cursor-pointer hover:bg-[#f6f7fb]" : "cursor-not-allowed opacity-50"
        }`}
      >
        <DropdownChevronRight color="#676879" />
      </button>
    </div>
  );
};

export default UsageTablePagination;
